<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column  mu-w-100">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">

            </div>
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                <section class="mu-d-flex">
                    <h1 class="mu-mb-00">Hierarchy details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon class="mcc-icon--secondary" width="32" height="32" name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>

                <section>
                    <div class="mu-d-flex mu-justify-content-end">
                        <button class="mcc-button mcc-button--soft-primary" v-if="fetchCall && chartData==null && dto.deleted==null && !newHierarchy" name="addRootGroup" id="addRootGroup" @click="addRootGroup()" title="Add group">
                            <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add group</span>
                        </button>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Users & groups</li>
                    <li>
                        <a class="linkCode" @click="redirectToList()">Hierarchies</a>
                    </li>
                    <li aria-current="page">{{hierarchyName}}</li>
                </ol>
            </nav>
        </div>
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="mcc-row" v-if="!updateCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="relativePosition">
            <div v-if="saveInProgress" class="spinner-overlay zIndex10">
                <div class="spinner-background"></div>
                <div class="spinner-flex spinner-text">
                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>
            <div class="mcc-card mu-p-06">
                <div class="mcc-row" v-if="fetchCall">
                    <div class="mcc-col">
                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="disableWarning" v-if="dto.deleted!= null" color="warning">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <p>
                                <strong>Warning!</strong>
                                <br />This group has been disabled and cannot be changed.
                                <br />
                                Reason: {{dto.deletedReason}}
                            </p>
                        </mcc-alert>
                    </div>
                </div>
                <div class="mcc-row" v-if="fetchCall">
                    <div class="mcc-col">
                        <form novalidate ref="hierarchyForm" id="hierarchyForm" @submit.prevent="saveHierarchy()">

                            <div class="mcc-card">
                                <div class="mcc-card__header">
                                    <h2 class="mcc-card__title">Details</h2>
                                </div>

                                <div class="mcc-card__body">
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                                <label for="name" class="mfc-label mu-mb-00 mfc-label--required">Name</label>
                                                <input type="text" id="name" name="name" required="" placeholder="Name" maxlength="50" :readonly="!newHierarchy" ref="name" :value="dto.name" :pattern="nameRegex" @change="updateName($event)">

                                            </div>
                                            <div class="mfc-textarea-wrapper mfc-form-input-container mu-mt-03 mfc-form-input-wrapper--width">
                                                <label for="description" class="mu-mb-00">Description</label>
                                                <textarea id="description" name="description" maxlength="100" :readonly="dto.deleted!=null" ref="description" placeholder="Description" :value="dto.description" :pattern="descRegex" @change="updateDescription($event)" @input="dto.description = $event.target.value" character-count=""></textarea>
                                                <div class="mfc-invalid-feedback"></div>
                                                <span class="mfc-help-text">You have {{100 - dto.description.length}} characters remaining</span>
                                            </div>
                                            <div>
                                                <div class="mfc-checkbox-wrapper mfc-form-input-container mu-mt-03">
                                                    <input type="checkbox" id="subTaskView" class="mfc-switch" :disabled="dto.deleted != null" name="subTaskView" :checked="dto.subTaskView" @change="dto.subTaskView = $event.target.checked" color="primary">
                                                    <label for="subTaskView">Sub task view</label>

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div class="mu-d-flex mu-justify-content-end d-flex justify-content-end  mu-mt-05">
                                        <div role="group" class="mcc-button-group mcc-button-group--spaced">
                                        <router-link v-if="newHierarchy" :to="CONTEXT_PATH + '/usersgroups/hierarchies'">
                                            <button class="mcc-button mcc-button--outline mu-mr-05" id="cancelBtn" title="Cancel" type="button">
                                                <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                            </button>
                                        </router-link>
                                        
                                            <button class="mcc-button mcc-button--soft-warning" title="Disable" v-if="!newHierarchy && dto.deleted==null" id="disableBtn" type="button" @click="openDisableDialog() ">
                                                <mcc-icon name="unavailable" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Disable</span>
                                            </button>
                                            <button class="mcc-button mcc-button--primary" v-if="dto.deleted!=null" id="enableBtn" @click="enableHierarchy()" title="Enable" type="button">
                                                <mcc-icon name="undo" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Enable</span>
                                            </button>
                                            <button class="mcc-button mcc-button--success" v-if="dto.deleted==null" id="saveBtn" title="Save" type="submit" >
                                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                    </div>

                </div>
                <div class="mcc-row" v-if="fetchCall && !newHierarchy && chartData!=null">
                    <div class="mcc-col mcc-col-xs-12 mcc-col-md-12 mcc-col-sm-12">

                        <form novalidate ref="hierarchyChartInfo">

                            <div class="mcc-card mu-mt-06">
                                <div class="mcc-card__header">
                                    <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                                        <section class="mu-d-flex">
                                            <h2 class="mcc-card__title">Chart</h2>

                                        </section>
                                        <section>
                                            <div role="group" class="mcc-button-group  mcc-button-group--spaced">

                                                <button class="mcc-button mcc-button--soft-danger" type="button" v-if="selectedNodeId!=null && showDelete" dialog="deleteGroupFromHierarchy" title="Delete" name="deleteCategoryBtn" id="deleteCategoryBtn" @click="removePopup()">
                                                    <mcc-icon name="trash_can" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Remove</span>
                                                </button>
                                                <button class="mcc-button mcc-button--soft-primary" type="button" v-if="selectedNodeId!=null" name="addChild" id="addChild" @click="addChildGroup('addChild','Add child')" title="Add child">
                                                    <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add child</span>
                                                </button>
                                                <button class="mcc-button mcc-button--soft-primary" type="button" v-if="selectedNodeId!=null && showAddNewRoot" name="addNewRootGroup" id="addNewRootGroup" @click="addChildGroup('addParent','New parent')" title="New parent">
                                                    <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">New parent</span>
                                                </button>
                                                <button class="mcc-button mcc-button--soft-primary" type="button" v-if="selectedNodeId!=null && showChangeParent" name="changeParentGroup" id="changeParentGroup" @click="changeParentGroup()" title="Change parent">
                                                    <mcc-icon name="edit" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Change parent</span>
                                                </button>
                                                <button class="mcc-button mcc-button--outline" type="button" v-if="position=='l2r' &&  !newHierarchy && chartData!=null" name="topDownBtn" id="topDownBtn" @click="renderGroupHierarchyData('t2b')" title="Top down">
                                                    <mcc-icon name="tree_structure" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Top down</span>
                                                </button>
                                                <button class="mcc-button mcc-button--outline" type="button" v-if="position=='t2b' &&  !newHierarchy && chartData!=null" name="leftRightBtn" id="leftRightBtn" @click="renderGroupHierarchyData('l2r')" title="Left right">
                                                    <mcc-icon name="tree_structure" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Left right</span>
                                                </button>
                                            </div>
                                        </section>

                                    </div>

                                </div>

                                <div class="mcc-card__body">
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <mcc-alert role="alert" class="mcc-alert mcc-alert--info">
                                                <mcc-icon name="info_popup" aria-hidden="true" ></mcc-icon>
                                                <div class="mu-fw-semi-bold">
                                                    People icon represents parent group and number in brackets shows number of users in that group. </div>

                                            </mcc-alert>

                                        </div>

                                    </div>

                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <div id="groupHierarchyChart"></div>

                                        </div>

                                    </div>

                                </div>

                            </div>
                        </form>

                    </div>

                </div>
            </div>

        </div>
    </div>

    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--warning mcc-dialog--xs" color="warning" ref="disableModal" v-if="dataLoaded" id="disableModal">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Disable</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDisableHierarchyDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <form id="disableform" novalidate>
                    <div class="mcc-row">
                        <div class="mcc-col">
                            <div v-if="updateDialog">
                                <div class="mfc-textarea-wrapper mfc-form-input-container">
                                    <label for="disableReason" class=" mfc-label--required">Disable reason</label>
                                    <textarea id="disableReason" ref="disableReason" name="disableReason" required maxlength="100" rows="6" :pattern="descRegex" :value="disableReason" @change="updateReason($event)" @input="disableReason = $event.target.value" character-count=""></textarea>
                                    <div  class="mfc-invalid-feedback">
                                    </div>
                                    <div class="mfc-help-text mu-mt-00">
                                        <span>You have {{100 - disableReason.length}} characters remaining</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="closeDisableHierarchyDialog()">Close</button>
                        <button type="submit" class="mcc-button mcc-button--warning" @click="disableHierarchy($event)">Save</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>

    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" color="danger" ref="deleteGroupFromHierarchy" v-if="selectedNodeId!=null && showDelete" id="deleteGroupFromHierarchy">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Remove group</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteGroupFromHierarchy.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            <div>
                                Are you sure you want to remove this group from hierarchy?
                            </div>

                        </div>

                    </div>
                </div>
                <div class="mcc-dialog__footer">

                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteGroupFromHierarchy.close()">No</button>
                        <button type="submit" class="mcc-button mcc-button--danger" @click="deleteGroupFromHierarchy($event)">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>

    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog  mcc-dialog--xs mcc-dialog--primary mu-overflow-visible" ref="groupDialogRef" v-show="dataLoaded" id="groupDialogRef">
            <section>
                <div class="mcc-dialog__header">
                    <h4>{{ popupText }}</h4>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closePopup()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body mu-overflow-visible" ref="filterDialogbody">
                    <form id="groupDialogForm" ref="groupDialogFormRef">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            <div v-show="updateGroupDialog">
                                <div class="mfc-slim-select-wrapper mfc-form-input-container mfc-slim-select-wrapper-sm mu-position-relative dialogSlimSelect" id="InvolvingselectIdDiv">
                                    <label for="group-selectId" class="mfc-label--required  mu-mb-00">Select group</label>
                                    <div id="InvolvingselectIdDiv"></div>
                                    <select required @change="selectedGroup = $event.target.value" ref="groupSelectRef" class="popupSlim" name="group-select" id="group-selectId">
                                        <option v-for="group in activeGroups" :selected="selectedGroup==group.id" :key="group.id" :value="group.id">{{group.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                </div>
                <div class="mcc-dialog__footer mu-justify-content-between">
                    <div>
                        <button class="mcc-button mcc-button--soft-primary" v-if="operationType != 'changeParent'" name="addNewGroup" id="addNewGroup" @click="addNewGroup()" title="Add new group">
                            <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add new group</span>
                        </button>
                    </div>
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="closePopup()">Cancel</button>
                        <button type="submit" class="mcc-button mcc-button--primary" @click="submitGroupDialog($event)">Save</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>

</div>
</template>

<script>
import HierarchyAPI from "../../../services/HierarchyAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages, displayErrorMessage, checkFormAndTextareaValidations
} from '@/formvalid.js';

export default {
    name: "GroupHierarchyEdit",
    data() {
        return {
            dto: {
                name: '',
                description: '',
                deleted: null,
                disableReason: ''
            },
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpText: constantMessages.BREADCRUMB_HELP["hierarchy.edit"],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            showHelpText: false,
            hierarchyId: this.$route.params.id,
            dataLoaded: false,
            hierarchyName: "",
            fetchCall: false,
            newHierarchy: false,
            disableReason: '',
            updateDialog: false,
            updateCall: true,
            hierarchyUpdateMsg: "message.groupHierarchy.update",
            chartData: null,
            position: 't2b',
            saveInProgress: false,
            selectedNodeId: null,
            showDelete: false,
            showAddNewRoot: false,
            showChangeParent: false,
            activeGroups: [],
            selectedGroup: "",
            updateGroupDialog: false,
            operationType: "",
            popupText: "Add group",
            modifiedBySelect: null,
            invalidDisableReason: false,
            isDescriptionValid: true
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        self.fetchCall = false;
        if (self.hierarchyId == 'new') {
            self.helpText = constantMessages.BREADCRUMB_HELP["hierarchy.create"];
            self.newHierarchy = true;
            self.hierarchyName = "Create new";
            self.fetchCall = true;
            self.hierarchyUpdateMsg = "message.groupHierarchy.add";
            return;
        }
        HierarchyAPI.getHierarchyInfo(self.hierarchyId)
            .then(result => {
                self.dataLoaded = true;
                self.dto = result.hierarchyInfo;
                self.chartData = result.hierarchy.data;
                self.hierarchyName = self.dto.name;
                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.hierarchy.details"] + " - " + self.hierarchyName;
                EventBus.$emit("update-pageTitle", pageTitle);
            }).finally(() => {
                self.fetchCall = true;
                if (self.chartData != null) {
                    self.loadHierarchy()
                }
            });
            self.modifiedBySelect = new SlimSelect({
                select: '#group-selectId',
                settings: {
                    contentPosition: 'absolute',
                    contentLocation: document.getElementById('InvolvingselectIdDiv')
                }
            })  
    },
    watch: {
        activeGroups(newValue, oldValue) {
            if (JSON.stringify(newValue) !== JSON.stringify(oldValue))  {
                let self= this;
                self.modifiedBySelect.setData(self.activeGroups);
            }
        },        
    },
    methods: {
        closePopup(){
            this.activeGroups = [];
            this.modifiedBySelect.setSelected('');
            this.$refs.groupDialogRef.close()
        },
        removePopup() {
            this.$refs.deleteGroupFromHierarchy.show();
        },
        showGroupDialog() {
            this.selectedGroup = "";
            this.$refs.groupDialogFormRef.classList.remove("ms-was-validated")
            this.$refs.groupDialogRef.show();
            // this.modifiedBySelect.setSelected('');
        },
        addNewGroup() {
            this.$refs.groupDialogRef.close();
            this.activeGroups = [];
            let self = this;
            let url = self.CONTEXT_PATH + '/usersgroups/groups/new?hierarchyId=' + self.dto.id
            if (self.operationType == "addChild") {
                url += "&parentId=" + self.selectedNodeId;
            } else if (self.operationType == "addParent") {
                url += "&childId=" + self.selectedNodeId;
            }
            self.$router.push(
                url
            );
        },
        submitGroupDialog(e) {
            let self = this;
            let form = $('#groupDialogForm')
            if(!self.isDescriptionValid){
                return;
            }
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            this.activeGroups = [];
            this.$refs.groupDialogRef.close();
            self.popupText = "Add group";
            self.dataLoaded = false;
            self.dataLoaded = true;
            let hierObj = {
                group: {
                    id: $("#group-selectId").val()
                },
                groupHierarchyChart: {
                    id: self.dto.id
                }
            };
            if (self.operationType == "addChild") {
                hierObj["parent"] = {
                    id: self.selectedNodeId
                }
            } else if (self.operationType == "addParent") {
                self.addNewParentGroup(hierObj);
                self.operationType = "";
                return;
            } else if (self.operationType == "changeParent") {
                self.changeHierarchyParent(self.selectedNodeId, $("#group-selectId").val());
                self.operationType = "";
                return;
            }
            self.saveUpdatedHierarchy(hierObj);
            self.operationType = "";
        },
        changeHierarchyParent(childId, parentId) {
            let self = this;
            self.saveInProgress = true;
            HierarchyAPI.updateParent(childId, parentId)
                .then(result => {
                    if (!result.error) {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[result.message]
                        });
                    } else {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[result.message]
                        });
                    }

                }).finally(() => {
                    self.saveInProgress = false;
                    self.refreshHierarchyData()

                });
        },
        saveUpdatedHierarchy(obj) {
            let self = this;
            self.saveInProgress = true;
            HierarchyAPI.addGroupToHierarchy(obj)
                .then(result => {
                    if (!result.error) {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[result.message]
                        });
                    } else {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[result.message]
                        });
                    }

                }).finally(() => {
                    self.saveInProgress = false;
                    self.refreshHierarchyData()

                });
        },
        refreshHierarchyData() {
            let self = this;
            self.saveInProgress = true;
            HierarchyAPI.getHierarchy(self.dto.id)
                .then(result => {
                    self.chartData = result.data;
                }).finally(() => {
                    self.saveInProgress = false;
                    self.loadHierarchy()
                });
        },
        addRootGroup() {
            let self = this;
            self.updateGroupDialog = false;
            self.saveInProgress = true;
            HierarchyAPI.getActiveGroups()
                .then(result => {
                    self.activeGroups = [{text: 'Select your option', value:'', placeholder: true}, ...result.data];
                }).finally(() => {
                    self.updateGroupDialog = true;
                    self.saveInProgress = false;
                    this.showGroupDialog();
                });
        },
        addNewParentGroup(hierObj) {
            let self = this;
            self.saveInProgress = true;
            HierarchyAPI.addNewParentGroup(self.selectedNodeId, hierObj)
                .then(result => {
                    if (!result.error) {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[result.message]
                        });
                    } else {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[result.message]
                        });
                    }

                }).finally(() => {
                    self.saveInProgress = false;
                    self.refreshHierarchyData()

                });
        },
        deleteGroupFromHierarchy(e) {
            let self = this;
            this.$refs.deleteGroupFromHierarchy.close();
            self.saveInProgress = true;
            HierarchyAPI.removeGroupFromHierarchy(self.selectedNodeId)
                .then(result => {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[result.message]
                    });

                }).finally(() => {
                    self.saveInProgress = false;
                    self.refreshHierarchyData()
                });
        },
        addChildGroup(type, text) {
            let self = this;
            self.operationType = type;
            self.popupText = text;
            self.updateGroupDialog = false;
            self.saveInProgress = true;
            HierarchyAPI.getGroupsNotInHierarchy(self.dto.id)
                .then(result => {
                    self.activeGroups = [{text: 'Select your option', value:'', placeholder: true}, ...result.data];
                }).finally(() => {
                    self.updateGroupDialog = true;
                    self.saveInProgress = false;
                    this.showGroupDialog();
                });
        },
        async loadHierarchy() {
            await this.$nextTick();
            let self = this;
            setTimeout(function () {
                self.renderGroupHierarchyData(self.position);
            }, 0)

        },
        changeParentGroup() {
            let self = this;
            self.activeGroups = [];
            self.operationType = "changeParent";
            self.popupText = "Change parent";
            self.updateGroupDialog = false;
            self.saveInProgress = true;
            let availableHierarchyData = JSON.parse(JSON.stringify(self.chartData));
            let selectedNodeHierarchy = JSON.parse(JSON.stringify(self.chartData));
            let childAndSubChildId = [];
            let availableGroupForParent = [];
            let selectedNodeValue = self.selectedNodeId;
            if (availableHierarchyData.id != selectedNodeValue) {
                selectedNodeHierarchy = self.exploreChildNode(availableHierarchyData.children);
            } else {
                return;
            }
            if (selectedNodeHierarchy != undefined && selectedNodeHierarchy != null &&
                selectedNodeHierarchy.id != undefined &&
                selectedNodeHierarchy.id != null) {
                childAndSubChildId = self.getChildAndSubChildId(selectedNodeHierarchy.children);
                childAndSubChildId.push(selectedNodeHierarchy.id);
            }

            availableGroupForParent = self.createDataForParentUpdate(
                availableHierarchyData.children, childAndSubChildId);
            if (availableHierarchyData != undefined && availableHierarchyData != null &&
                availableHierarchyData.id != undefined &&
                availableHierarchyData.id != null &&
                childAndSubChildId.indexOf(availableHierarchyData.id) == -1) {
                availableGroupForParent.push({
                    id: availableHierarchyData.id,
                    name: availableHierarchyData.groupName
                });
            }

            if (availableGroupForParent.length > 0) {
                self.activeGroups = [{text: 'Select your option', value:'', placeholder: true}, ...availableGroupForParent];
            }

            setTimeout(function () {
                self.updateGroupDialog = true;
                self.saveInProgress = false;
                self.showGroupDialog();
            }, 0)
        },
        exploreChildNode(availableData) {
            let self = this;
            let selectedNodeHierarchy = '';
            let selectedNodeValue = self.selectedNodeId;
            for (let i = 0; i < availableData.length; i++) {
                let data = availableData[i];
                if (selectedNodeHierarchy != '') {
                    break;
                }
                if (data.id == selectedNodeValue) {
                    selectedNodeHierarchy = data;
                    break;
                } else {
                    selectedNodeHierarchy = self.exploreChildNode(data.children);
                }
            }
            return selectedNodeHierarchy;
        },
        getChildAndSubChildId(availableData) {
            let self = this;
            let childAndSubChildId = [];
            let subChildId = [];
            for (let i = 0; i < availableData.length; i++) {
                let data = availableData[i];
                childAndSubChildId.push(data.id);
                subChildId = self.getChildAndSubChildId(data.children);
                if (subChildId.length > 0) {
                    childAndSubChildId.push.apply(childAndSubChildId, subChildId);
                }
            }
            return childAndSubChildId;
        },
        createDataForParentUpdate(availableData, childAndSubChildId) {
            let self = this;
            let availableGroupData = [];
            let subChildGroupArray = [];
            for (let i = 0; i < availableData.length; i++) {
                let data = availableData[i];
                if (childAndSubChildId.indexOf(data.id) == -1) {
                    availableGroupData.push({
                        id: data.id,
                        name: data.groupName
                    });
                }
                subChildGroupArray = self.createDataForParentUpdate(data.children,
                    childAndSubChildId);
                if (subChildGroupArray.length > 0) {
                    availableGroupData.push.apply(availableGroupData,
                        subChildGroupArray);
                }

            }
            return availableGroupData;
        },
        renderGroupHierarchyData(position) {
            let self = this;
            self.position = position;
            self.selectedNodeId = null;
            $('#groupHierarchyChart').html('');
            if (self.chartData == null) {
                return;
            }
            $('#groupHierarchyChart').orgchart({
                'data': self.chartData,
                'draggable': self.dto.deleted == null,
                'nodeContent': 'title',
                'zoom': false,
                'toggleSiblingsResp': false,
                'direction': position,
                'createNode': function ($node, data) {
                    let secondMenuIcon = $('<i>', {
                        click: function () {
                            $(this).parent().find('.user-list').toggle();
                        }
                    });
                    $node.append(secondMenuIcon);
                }
            }).on('click', '.node', function () {
                if (self.dto.deleted != null) {
                    return;
                }
                self.selectedNodeId = $(this)[0].id;
                self.showDelete = ($(this).parent().attr('colspan') == null || $(this).parent().attr('colspan') == 0);
                self.showAddNewRoot = (self.chartData.id == self.selectedNodeId);
                self.showChangeParent = (self.chartData.id != self.selectedNodeId);

            }).on('click', '.orgchart', function (event) {
                if (!$(event.target).closest('.node').length) {
                    self.selectedNodeId = null;
                }
            }).children('.orgchart').on('nodedropped.orgchart', function (event) {
                self.selectedNodeId = null;
                self.changeHierarchyParent(event.draggedNode[0].id, event.dropZone[0].id);
            });

            if (self.position == "l2r") {
                $("#groupHierarchyChart").css("height", $(".orgchart").outerWidth());
            } else {
                $("#groupHierarchyChart").css("height", 'auto');
            }
        },
        openDisableDialog() {
            let self = this;
            this.disableReason = "";
            self.$refs.disableModal.show();
            this.updateDialog = true;
        },
        enableHierarchy() {
            let self = this;
            self.saveInProgress = true;
            self.selectedNodeId = null;
            return HierarchyAPI.updateState(
                self.hierarchyId, ""
            ).then(response => {
                if (!response.error) {

                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES["hierarchy.enable.success"]
                    });
                    self.dto = response.data;
                    if (self.dto.deleted == null) {
                        $("#subTaskView-field").removeAttr("disabled");
                    }
                    self.saveInProgress = false;

                }
            });
        },
        closeDisableHierarchyDialog() {
            let form = $('#disableform')
            form[0].classList.remove("ms-was-validated");
            this.$refs.disableModal.close()
            this.updateDialog = false;
        },
        disableHierarchy(e) {
            let self = this;
            let form = $('#disableform')
            if(!checkFormAndTextareaValidations('disableReason',this.descRegex,form))
            {
                return;
            }
            this.$refs.disableModal.close()
            self.saveInProgress = true;
            self.selectedNodeId = null;

            return HierarchyAPI.updateState(
                self.hierarchyId, self.disableReason
            ).then(response => {
                if (!response.error) {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES["hierarchy.disable.success"]
                    });
                    self.dto = response.data;
                    self.saveInProgress = false;
                    self.$router.push(
                        this.CONTEXT_PATH + '/usersgroups/hierarchies'
                    );

                }
            });
        },
        saveHierarchy() {
            let self = this;
            let form = $('#hierarchyForm')
            if (this.dto.description ) {
                if(!checkFormAndTextareaValidations('description',this.descRegex,form))
            {
                return;
            }
            } else {
                $(self.$refs.description)[0].classList.remove("ms-is-invalid");
            }     
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }    
            self.saveInProgress = true;
            HierarchyAPI.saveHierarchy(self.dto).then(response => {
                self.saveInProgress = false;

                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        } else {
                            EventBus.$emit('error-notification', {
                                "msg": constantMessages.MESSAGES[response.messages[k]]
                            });
                        }

                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[self.hierarchyUpdateMsg]
                    });
                    if (self.newHierarchy) {
                        this.$router
                            .push(
                                this.CONTEXT_PATH + "/usersgroups/hierarchies/" + response.data.id
                            )
                            .catch(err => {});
                    }
                }
            });
        },
        updateReason(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.disableReason), "Disable reason is required")
                self.$refs.disableReason.classList.add("ms-is-invalid")
                self.invalidDisableReason = true;
            } else if (!event.target.value.match(this.descRegex)) {
                displayErrorMessage($(self.$refs.disableReason), "Disable reason must be valid")
                self.$refs.disableReason.classList.add("ms-is-invalid")
                self.invalidDisableReason = true;
            } else {
                self.$refs.disableReason.classList.remove("ms-is-invalid")
                self.invalidDisableReason = false;
            }
            self.disableReason = event.target.value;
        },

        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }

            self.dto.name = event.target.value;
        },
        updateDescription(event) {
            let self = this;
            if (event.target.value.length > 100) {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.length"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else if (!event.target.value.match(this.descRegex) && event.target.value != "") {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.invalid"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else {
                self.$refs.description.classList.remove("ms-is-invalid")
                self.isDescriptionValid = true;
            }
            self.dto.description = event.target.value;
        },

        handleValidation() {
            let invalid = false;
            let self = this;
            if (!this.dto?.name) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
                invalid = true;
            } else if (this.dto.name > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!this.dto.name.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            }

            return invalid;
        },
        redirectToList() {
            let self = this;
            if (!self.newHierarchy) {
                localStorage.setItem("GroupHierarchyList", "GroupHierarchyList");
            }
            this.$router.push(
                this.CONTEXT_PATH + '/usersgroups/hierarchies'
            );
        }
    }
}
</script>


